import categorizedListWidget from "../categorizedListWidget.js";

/**
 * `basCategorizedListWidget` is a special list fitering out the presets when displaying all the KeyFigures
 *
 * @return {basCategorizedListWidget}
 */
function basCategorizedListWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = categorizedListWidget(spec, my);

	my.categoriesToShow = function () {
		// This should be a supercall
		return my.categories.filter(
			(category) => category.getGroup().rawValue() === "BAS Groups",
		);
	};

	return that;
}

export default basCategorizedListWidget;
